// extracted by mini-css-extract-plugin
export default {"m":"d9408491d9","title":"_6b53bbbf37","feedback_inner_title":"_30e9704651","textarea":"bf6107a50b","radio":"_9f128df235","text":"ddecb1d2da"};